import {
  PAYPAL_CHECKER_ERROR,
  PAYPAL_CHECKER_REQUEST,
  PAYPAL_CHECKER_RESET,
  PAYPAL_CHECKER_SUCCESS,
} from "./ActionType";
import { ROUTES_NAME } from "../../../config/constants";
import { ACCESS_TOKEN } from "../../../constants";
import { authenticatedFetch } from "../../../util/authenticatedFetch";

let requestSequence = 0;

const createRequestMeta = (shopId) => {
  const normalizedShopId = String(shopId ?? "");
  requestSequence += 1;
  return {
    shopId: normalizedShopId,
    requestId: `paypalChecker:${normalizedShopId}:${Date.now()}:${requestSequence}`,
  };
};

const readResponsePayload = async (response) => {
  if (typeof response.text === "function") {
    const text = await response.text();
    if (!text) return null;
    try {
      return JSON.parse(text);
    } catch (_error) {
      return { message: text };
    }
  }
  if (typeof response.json === "function") return response.json();
  return null;
};

const responseError = (payload, response) =>
  [payload?.message, payload?.error, payload?.detail].find(
    (value) => typeof value === "string" && value.trim()
  ) || `PayPal checker request failed (${response.status})`;

export const getpaypalCheckerData = (payload) => async (dispatch) => {
  const target = {
    shopId: String(payload?.shopId ?? ""),
    shopMerchantAccountId: payload?.shopMerchantAccountId || null,
    transactionId: payload?.transactionId || "",
    trackingNumber: payload?.trackingNumber || "",
  };
  const meta = createRequestMeta(target.shopId);
  dispatch({ type: PAYPAL_CHECKER_REQUEST, meta });

  try {
    const response = await authenticatedFetch(
      `${process.env.REACT_APP_BACKEND_API_URL}${ROUTES_NAME.paypalChecker()}`,
      {
        method: "POST",
        body: JSON.stringify({
          storeId: target.shopId,
          shopMerchantAccountId: target.shopMerchantAccountId,
          transactionId: target.transactionId,
          trackingNumber: target.trackingNumber,
        }),
        credentials: "include",
        headers: {
          Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
          "Content-Type": "application/json",
          Origin: `${process.env.REACT_APP_URL}`,
        },
      }
    );
    const data = await readResponsePayload(response);
    if (!response.ok) throw new Error(responseError(data, response));

    dispatch({ type: PAYPAL_CHECKER_SUCCESS, payload: data, meta });
    return { ok: true, payload: data, meta };
  } catch (error) {
    const message = error?.message || "PayPal checker request failed";
    dispatch({ type: PAYPAL_CHECKER_ERROR, payload: message, meta });
    return { ok: false, error: message, meta };
  }
};

export const resetPaypalChecker = () => ({ type: PAYPAL_CHECKER_RESET });
